var map = {
	"./ar.png": 387,
	"./branchreceipt.png": 718,
	"./cart.png": 868,
	"./cloudlogo.png": 336,
	"./doordelivery.png": 688,
	"./en.png": 562,
	"./invoice.png": 483,
	"./navheader.png": 721,
	"./search.png": 289
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 197;